import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES = 'RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES';

export const fetchFeatureDataResource: RouteResource<string | null> = createResource<string | null>(
	{
		type: RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES,
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-offering-catalogue-features", jiraSpaEntry: "async-resource-offering-catalogue-features" */ './getData.tsx'
			),
		maxAge: 30 * 60 * 1000,
	},
);

export const getOfferingCatalogueFeaturesResource = (): never[] => [];
